let forms = document.querySelectorAll('form');
let buttons = document.querySelectorAll('button[type="submit"]');
let buttons2 = document.querySelectorAll('button[name="submit"]');

[].forEach.call(forms, el => {
  el.addEventListener('submit', () => {
    console.log('Submitting!');
    [].forEach.call(buttons, btn => {
        btn.classList.add('is-loading');
        btn.disabled = true;
    });
  });
});

window.startLoading = function() {
  [].forEach.call(buttons, btn => {
      btn.classList.add('is-loading');
      btn.disabled = true;
  });
  [].forEach.call(buttons2, btn => {
      btn.classList.add('is-loading');
      btn.disabled = true;
  });
}

window.stopLoading = function() {
  [].forEach.call(buttons, btn => {
      btn.classList.remove('is-loading');
      btn.disabled = false;
  });
  [].forEach.call(buttons2, btn => {
      btn.classList.remove('is-loading');
      btn.disabled = false;
  });
}



// WEBPACK FOOTER //
// ./resources/assets/website/scripts/form-loader.js